/**
 * Copy to clipboard buttons, used for the server and TeamSpeak addresses.
 */

import { text } from "../core/i18n";
import { queryAll } from "../core/dom";
import { toast } from "../core/toast";

/** Copy `value` to the clipboard, falling back to a hidden text area. */
export async function copyText(value: string): Promise<boolean> {
    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(value);

            return true;
        } catch {
            // Falls through to the legacy path below.
        }
    }

    const area = document.createElement("textarea");
    area.value = value;
    area.setAttribute("readonly", "");
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();

    let copied = false;
    try {
        copied = document.execCommand("copy");
    } catch {
        copied = false;
    }

    area.remove();

    return copied;
}

/** Wire every element carrying a `data-copy` attribute. */
export function initClipboard(): void {
    for (const button of queryAll<HTMLElement>("[data-copy]")) {
        button.addEventListener("click", () => {
            const value = button.dataset["copy"] ?? "";
            if (!value) {
                return;
            }

            void copyText(value).then((copied) => {
                toast(
                    copied
                        ? text("js.clipboard.copied", "Skopírované do schránky: {value}", { value })
                        : text("js.clipboard.failed", "Skopírovanie sa nepodarilo."),
                    copied ? "success" : "error",
                );
            });
        });
    }
}
